import { Card } from '@/shared/components/ui/card';
import { Skeleton } from '@/shared/components/ui/skeleton';

type AdvisorProfileSkeletonProps = {
  fullPage?: boolean;
};

export const AdvisorProfileSkeleton = ({ fullPage = false }: AdvisorProfileSkeletonProps) => {
  const content = (
    <div className="container mx-auto max-w-6xl px-4 py-8 space-y-6">
      <Skeleton className="h-6 w-36" />
      <Card className="p-6">
        <div className="grid gap-6 md:grid-cols-[220px_1fr]">
          <Skeleton className="h-56 w-full" />
          <div className="space-y-4">
            <Skeleton className="h-8 w-64" />
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-10 w-40" />
          </div>
        </div>
      </Card>
    </div>
  );

  if (!fullPage) {
    return <div data-testid="advisor-profile-skeleton">{content}</div>;
  }

  return (
    <div className="min-h-screen bg-background" data-testid="advisor-profile-skeleton">
      {content}
    </div>
  );
};
